module.exports = __webpack_public_path__ + "images/mdj/members/mypage/top/top_bnr01_sp-eb2655ad7aa66829453c2bc69c263312.jpg";